import { render, staticRenderFns } from "./accessories-list.vue?vue&type=template&id=610de530&scoped=true&"
import script from "./accessories-list.vue?vue&type=script&lang=js&"
export * from "./accessories-list.vue?vue&type=script&lang=js&"
import style0 from "./accessories-list.vue?vue&type=style&index=0&id=610de530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610de530",
  null
  
)

export default component.exports